import React from 'react';
import './clientAddressAutocompleteForm.css';

export default function ClientAddressAutocomplete({ onConfirm, onCancel }) {
  return (
    <div className="overlay">
      <div className="client-address-autocomplete-container">
        <span className="overlay-close" onClick={onCancel}>
          &times;
        </span>
        <p>Autoremplir adresse d'enlèvement ou de livraison ?</p>
        <div className="client-address-autocomplete-buttons-container">
          <button type="button" onClick={() => onConfirm('pickup')}>
            ADRESSE D'ENLEVEMENT
          </button>
          <button type="button" onClick={() => onConfirm('delivery')}>
            ADRESSE DE LIVRAISON
          </button>
        </div>
      </div>
    </div>
  );
}
